import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const OPENED_STATE_KEY_LPL30D = 'LOWEST_PRODUCT_PRICE_30D_MORE_INFO';

export const useLowestProductPriceStateManager = (
  productId?: string | number,
) => {
  const key = `${OPENED_STATE_KEY_LPL30D}-${productId ?? 'unknown'}`;
  return useOpenedStateManager(key);
};
